"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ref = /*#__PURE__*/_react["default"].createElement("link", {
  rel: "stylesheet",
  href: "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css",
  integrity: "sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN",
  crossOrigin: "anonymous"
});
var _ref2 = /*#__PURE__*/_react["default"].createElement("link", {
  rel: "preconnect",
  href: "https://fonts.gstatic.com"
});
var _ref3 = /*#__PURE__*/_react["default"].createElement("link", {
  href: "https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap",
  rel: "stylesheet"
});
var _ref4 = /*#__PURE__*/_react["default"].createElement("link", {
  href: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
  rel: "stylesheet"
});
var FuseFonts = function FuseFonts(props) {
  var fonts = props.fonts,
    iconFonts = props.iconFonts,
    monoFonts = props.monoFonts,
    forceLoad = props.forceLoad;
  if (FuseFonts.fontLoadCounter < 1) FuseFonts.fontLoadCounter++;
  return (FuseFonts.fontLoadCounter === 0 || forceLoad) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, iconFonts && _ref, (monoFonts || fonts) && _ref2, monoFonts && _ref3, fonts && _ref4);
};
FuseFonts.fontLoadCounter = -1;
FuseFonts.defaultProps = {
  fonts: true,
  forceLoad: true,
  iconFonts: false,
  monoFonts: true
};
FuseFonts.displayName = 'FuseFonts';
FuseFonts.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Load regular fonts (Roboto family)
   */
  fonts: _propTypes["default"].bool,
  /**
   * Attempt to load resources every time FuseFonts is rendered
   */
  forceLoad: _propTypes["default"].bool,
  /**
   * Load icon fonts.
   */
  iconFonts: _propTypes["default"].bool,
  /**
   * Load monospaced fonts (Roboto Mono).
   */
  monoFonts: _propTypes["default"].bool
} : {};
var _default = FuseFonts;
exports["default"] = _default;